var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Voice',{attrs:{"detail":{
  no: '07',
  belong: 'ＪＲ九州ホテル鹿児島',
  profile: 'ＪＲ九州ホテル鹿児島',
  title: 'ホテルスタッフ',
  name: '村岡 史織',
  date: '２０２１年入社',
  sm: {
    belong: 'ＪＲ九州ホテル鹿児島',
    name: 'ホテルスタッフ',
  },
  intro: 'ホテルは私らしく成長できる場所。笑顔と明るさ、特技も活かして誰もが楽しい空間を作りたい。',
  content: [
    {
      title: 'サービス業の最高峰で挑戦したい',
      text: '学生時代にカフェのアルバイトを経験し、接客業に興味を持ちました。そして、より自分が成長できる場として、サービス業の最高峰だと感じていたホテル業界への就職を志し、ＪＲ九州ホテルズアンドリゾーツに入社しました。勤続年数に合わせてサービス向上のための研修などが充実しており、成長を目指すためには最適な環境です。私はまだ入社2年ほどですので、ここで多くの経験を積んで、自分にしかできないサービスを見つけていきたいと思います。',
    },
    {
      title: '周りのサポートに安心',
      text: '現在はフロントで勤務しています。夜勤もあるシフト勤務となりますが、勤務後や休日に習い事を楽しみながらプライベートと仕事を両立できているので、むしろ働きやすさを感じています。仕事内容は、チェックイン・チェックアウトだけでなく、清掃や事務作業などもあります。最初はいろいろな業務に戸惑うこともありましたが、周りの先輩方に優しくサポートしていただいています。',
    },
    {
      title: 'ゴールがないからよりよいサービスを追求できる',
      text: 'この仕事のやりがいは「正解がない」ことだと考えています。特にフロントスタッフは、お客さま一人ひとりに寄り添った対応をする必要があります。そのために、自分がやりたいことを表現できるのも、この会社の魅力だと思います。私は絵を描くのが好きなので、クリスマスやバレンタインなどイベントごとのイラストを描いてフロントの横に置き、お客さまに少しでも喜んでもらえるよう工夫しています。',
    },
    {
      title: '「ありがとう」の一言がなにより成長の糧',
      text: 'お客さまからのアンケートで私の接客が褒められたり、私が描いたイラストをスマートフォンなどで撮影していただいたりと、日々いろいろな場面で喜びを感じています。また、今年は初めて後輩ができるのを楽しみにしています。明るく元気な性格を活かして、後輩の話に耳を傾けながら、私自身も成長していけるような先輩になりたいです。',
    } ],
  career: [
    {
      year: '2021',
      text: 'ＪＲ九州ホテル鹿児島にホテルスタッフとして勤務',
      isLast: true,
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    },
    {
      year: '',
      text: '',
    } ],
  message: 'ホテルというとかしこまった接客のイメージもあるかもしれませんが、その人らしさも活かせる職場です。自分の知識や趣味を通じてお客さまと触れ合うことができますし、小さな気づきで喜んでいただけることもあります。ぜひ、この楽しい仕事をみなさんにも経験してほしいと思います！',
  navi: {
    prev: {
      title: 'サービススタッフから、本社勤務へ。ホテル現場とオフィスを円滑につなぎ、会社全体の成長に関わりたい',
      path: '06',
    },
    next: {
      title: 'ホテル業界に魅せられ理想を追求。「感謝」と「笑顔」を忘れずにわたしたちにできる最高のサービスを。',
      path: '01',
    },
  },
}}})}
var staticRenderFns = []

export { render, staticRenderFns }